module.exports = __webpack_public_path__ + "img/vote_btn.84e8ab8a.png";